import { render, staticRenderFns } from "./NotesPanel.vue?vue&type=template&id=39e639ae&scoped=true&"
import script from "./NotesPanel.vue?vue&type=script&lang=js&"
export * from "./NotesPanel.vue?vue&type=script&lang=js&"
import style1 from "./NotesPanel.vue?vue&type=style&index=1&id=39e639ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e639ae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VCard,VTextarea,VToolbar})
